// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function MM_cmp_import_from_json(props) {
  var onCancel = props.onCancel;
  var onImport = props.onImport;
  var match = React.useState(function () {
        return "";
      });
  var setText = match[1];
  var text = match[0];
  var actUpdateText = function (text) {
    Curry._1(setText, (function (param) {
            return text;
          }));
  };
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onImport, text);
                      }),
                    variant: "contained",
                    children: "Import"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCancel, undefined);
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: text,
                            label: "Editor state in JSON format",
                            size: "small",
                            style: {
                              width: "800px"
                            },
                            multiline: true,
                            maxRows: 10,
                            onChange: (function (param) {
                                return Expln_React_common.evt2str(actUpdateText, param);
                              }),
                            autoFocus: true
                          }), rndButtons(undefined)))
            });
}

var make = MM_cmp_import_from_json;

exports.make = make;
/* react Not a pure module */
